import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["alignSelf", "background", "blockSize", "border", "borderBlock", "borderBlockEnd", "borderBlockStart", "borderInline", "borderInlineEnd", "borderInlineStart", "borderRadius", "borderRadiusEndEnd", "borderRadiusEndStart", "borderRadiusStartEnd", "borderRadiusStartStart", "color", "display", "flex", "flexBasis", "flexGrow", "flexShrink", "inlineSize", "inset", "insetBlock", "insetBlockEnd", "insetBlockStart", "insetInline", "insetInlineEnd", "insetInlineStart", "justifySelf", "lineHeight", "margin", "marginBlock", "marginBlockEnd", "marginBlockStart", "marginInline", "marginInlineEnd", "marginInlineStart", "maxBlockSize", "maxInlineSize", "minBlockSize", "minInlineSize", "opacity", "overflow", "overflowX", "overflowY", "padding", "paddingBlock", "paddingBlockEnd", "paddingBlockStart", "paddingInline", "paddingInlineEnd", "paddingInlineStart", "position", "textAlign", "zIndex", "children"];
import styled from 'styled-components';
import { forwardRef } from 'react';
import { makeCustomProperty, makeBorderCustomProperty, makeSpacingCustomProperty, makeFlexDeclaration } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledLayoutBox = styled.div.withConfig({
  displayName: "LayoutBox__StyledLayoutBox",
  componentId: "sc-36tgdd-0"
})(["", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";"], ({
  $alignSelf
}) => $alignSelf && `align-self: ${$alignSelf};`, ({
  $background
}) => $background && `background: ${makeCustomProperty($background)};`, ({
  $blockSize
}) => $blockSize && `block-size: ${$blockSize}`, ({
  $border
}) => $border && `border: ${makeBorderCustomProperty($border)};`, ({
  $borderBlock
}) => $borderBlock && `border-block: ${makeBorderCustomProperty($borderBlock)};`, ({
  $borderBlockEnd
}) => $borderBlockEnd && `border-block-end: ${makeBorderCustomProperty($borderBlockEnd)};`, ({
  $borderBlockStart
}) => $borderBlockStart && `border-block-start: ${makeBorderCustomProperty($borderBlockStart)};`, ({
  $borderInline
}) => $borderInline && `border-inline: ${makeBorderCustomProperty($borderInline)};`, ({
  $borderInlineEnd
}) => $borderInlineEnd && `border-inline-end: ${makeBorderCustomProperty($borderInlineEnd)};`, ({
  $borderInlineStart
}) => $borderInlineStart && `border-inline-start: ${makeBorderCustomProperty($borderInlineStart)};`, ({
  $borderRadius
}) => $borderRadius && `border-radius: ${makeCustomProperty($borderRadius)};`, ({
  $borderRadiusEndEnd
}) => $borderRadiusEndEnd && `border-end-end-radius: ${makeCustomProperty($borderRadiusEndEnd)};`, ({
  $borderRadiusEndStart
}) => $borderRadiusEndStart && `border-end-start-radius: ${makeCustomProperty($borderRadiusEndStart)};`, ({
  $borderRadiusStartEnd
}) => $borderRadiusStartEnd && `border-start-end-radius: ${makeCustomProperty($borderRadiusStartEnd)};`, ({
  $borderRadiusStartStart
}) => $borderRadiusStartStart && `border-start-start-radius: ${makeCustomProperty($borderRadiusStartStart)};`, ({
  $color
}) => $color && `color: ${makeCustomProperty(`text-color-${$color}`)};`, ({
  $display
}) => $display && `display: ${$display};`, ({
  $flex
}) => makeFlexDeclaration('flex', $flex), ({
  $flexBasis
}) => makeFlexDeclaration('flex-basis', $flexBasis), ({
  $flexGrow
}) => makeFlexDeclaration('flex-grow', $flexGrow), ({
  $flexShrink
}) => makeFlexDeclaration('flex-shrink', $flexShrink), ({
  $inlineSize
}) => $inlineSize && `inline-size: ${$inlineSize}`, ({
  $inset
}) => $inset && `inset: ${makeSpacingCustomProperty($inset)};`, ({
  $insetBlock
}) => $insetBlock && `inset-block: ${makeSpacingCustomProperty($insetBlock)};`, ({
  $insetBlockEnd
}) => $insetBlockEnd && `inset-block-end: ${makeSpacingCustomProperty($insetBlockEnd)};`, ({
  $insetBlockStart
}) => $insetBlockStart && `inset-block-start: ${makeSpacingCustomProperty($insetBlockStart)};`, ({
  $insetInline
}) => $insetInline && `inset-inline: ${makeSpacingCustomProperty($insetInline)};`, ({
  $insetInlineEnd
}) => $insetInlineEnd && `inset-inline-end: ${makeSpacingCustomProperty($insetInlineEnd)};`, ({
  $insetInlineStart
}) => $insetInlineStart && `inset-inline-start: ${makeSpacingCustomProperty($insetInlineStart)};`, ({
  $justifySelf
}) => $justifySelf && `justify-self: ${$justifySelf}`, ({
  $lineHeight
}) => $lineHeight && `line-height: ${$lineHeight};`, ({
  $margin
}) => $margin && `margin: ${makeSpacingCustomProperty($margin)};`, ({
  $marginBlock
}) => $marginBlock && `margin-block: ${makeSpacingCustomProperty($marginBlock)};`, ({
  $marginBlockEnd
}) => $marginBlockEnd && `margin-block-end: ${makeSpacingCustomProperty($marginBlockEnd)};`, ({
  $marginBlockStart
}) => $marginBlockStart && `margin-block-start: ${makeSpacingCustomProperty($marginBlockStart)};`, ({
  $marginInline
}) => $marginInline && `margin-inline: ${makeSpacingCustomProperty($marginInline)};`, ({
  $marginInlineEnd
}) => $marginInlineEnd && `margin-inline-end: ${makeSpacingCustomProperty($marginInlineEnd)};`, ({
  $marginInlineStart
}) => $marginInlineStart && `margin-inline-start: ${makeSpacingCustomProperty($marginInlineStart)};`, ({
  $maxBlockSize
}) => $maxBlockSize && `max-block-size: ${$maxBlockSize}`, ({
  $maxInlineSize
}) => $maxInlineSize && `max-inline-size: ${$maxInlineSize}`, ({
  $minBlockSize
}) => $minBlockSize && `min-block-size: ${$minBlockSize}`, ({
  $minInlineSize
}) => $minInlineSize && `min-inline-size: ${$minInlineSize}`, ({
  $opacity
}) => $opacity && `opacity: ${$opacity};`, ({
  $overflow
}) => $overflow && `overflow: ${$overflow};`, ({
  $overflowX
}) => $overflowX && `overflow-x: ${$overflowX};`, ({
  $overflowY
}) => $overflowY && `overflow-y: ${$overflowY};`, ({
  $padding
}) => $padding && `padding: ${makeSpacingCustomProperty($padding)};`, ({
  $paddingBlock
}) => $paddingBlock && `padding-block: ${makeSpacingCustomProperty($paddingBlock)};`, ({
  $paddingBlockEnd
}) => $paddingBlockEnd && `padding-block-end: ${makeSpacingCustomProperty($paddingBlockEnd)};`, ({
  $paddingBlockStart
}) => $paddingBlockStart && `padding-block-start: ${makeSpacingCustomProperty($paddingBlockStart)};`, ({
  $paddingInline
}) => $paddingInline && `padding-inline: ${makeSpacingCustomProperty($paddingInline)};`, ({
  $paddingInlineEnd
}) => $paddingInlineEnd && `padding-inline-end: ${makeSpacingCustomProperty($paddingInlineEnd)};`, ({
  $paddingInlineStart
}) => $paddingInlineStart && `padding-inline-start: ${makeSpacingCustomProperty($paddingInlineStart)};`, ({
  $position
}) => $position && `position: ${$position} !important;`, ({
  $textAlign
}) => $textAlign && `text-align: ${$textAlign};`, ({
  $zIndex
}) => $zIndex && `z-index: ${$zIndex};`);
export const LayoutBox = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      alignSelf,
      background,
      blockSize,
      border,
      borderBlock,
      borderBlockEnd,
      borderBlockStart,
      borderInline,
      borderInlineEnd,
      borderInlineStart,
      borderRadius,
      borderRadiusEndEnd,
      borderRadiusEndStart,
      borderRadiusStartEnd,
      borderRadiusStartStart,
      color,
      display,
      flex,
      flexBasis,
      flexGrow,
      flexShrink,
      inlineSize,
      inset,
      insetBlock,
      insetBlockEnd,
      insetBlockStart,
      insetInline,
      insetInlineEnd,
      insetInlineStart,
      justifySelf,
      lineHeight,
      margin,
      marginBlock,
      marginBlockEnd,
      marginBlockStart,
      marginInline,
      marginInlineEnd,
      marginInlineStart,
      maxBlockSize,
      maxInlineSize,
      minBlockSize = '0',
      minInlineSize = '0',
      opacity,
      overflow,
      overflowX,
      overflowY,
      padding,
      paddingBlock,
      paddingBlockEnd,
      paddingBlockStart,
      paddingInline,
      paddingInlineEnd,
      paddingInlineStart,
      position,
      textAlign,
      zIndex,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledLayoutBox, Object.assign({
    $alignSelf: alignSelf,
    $background: background,
    $blockSize: blockSize,
    $border: border,
    $borderBlock: borderBlock,
    $borderBlockEnd: borderBlockEnd,
    $borderBlockStart: borderBlockStart,
    $borderInline: borderInline,
    $borderInlineEnd: borderInlineEnd,
    $borderInlineStart: borderInlineStart,
    $borderRadius: borderRadius,
    $borderRadiusEndEnd: borderRadiusEndEnd,
    $borderRadiusEndStart: borderRadiusEndStart,
    $borderRadiusStartEnd: borderRadiusStartEnd,
    $borderRadiusStartStart: borderRadiusStartStart,
    $color: color,
    $display: display,
    $flex: flex,
    $flexBasis: flexBasis,
    $flexGrow: flexGrow,
    $flexShrink: flexShrink,
    $inlineSize: inlineSize,
    $inset: inset,
    $insetBlock: insetBlock,
    $insetBlockEnd: insetBlockEnd,
    $insetBlockStart: insetBlockStart,
    $insetInline: insetInline,
    $insetInlineEnd: insetInlineEnd,
    $insetInlineStart: insetInlineStart,
    $justifySelf: justifySelf,
    $lineHeight: lineHeight,
    $margin: margin,
    $marginBlock: marginBlock,
    $marginBlockEnd: marginBlockEnd,
    $marginBlockStart: marginBlockStart,
    $marginInline: marginInline,
    $marginInlineEnd: marginInlineEnd,
    $marginInlineStart: marginInlineStart,
    $maxBlockSize: maxBlockSize,
    $maxInlineSize: maxInlineSize,
    $minBlockSize: minBlockSize,
    $minInlineSize: minInlineSize,
    $opacity: opacity,
    $overflow: overflow,
    $overflowX: overflowX,
    $overflowY: overflowY,
    $padding: padding,
    $paddingBlock: paddingBlock,
    $paddingBlockEnd: paddingBlockEnd,
    $paddingBlockStart: paddingBlockStart,
    $paddingInline: paddingInline,
    $paddingInlineEnd: paddingInlineEnd,
    $paddingInlineStart: paddingInlineStart,
    $position: position,
    $textAlign: textAlign,
    $zIndex: zIndex,
    ref: ref
  }, rest, {
    children: children
  }));
});